import React, { useEffect, useState } from "react";
import MainPageComponent from "./main.page";
import { useDispatch } from "react-redux";
import {fetchAccessRightStructure, openCreationDialog} from "modules/role-access-right/redux";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import {AccessRights} from "lib/constants/accessRights"
import LoadingComponent from "components/loading";
import { getLang } from "app/feature/constants";
import {canAccess} from "../../../profile/redux/selector/profile.selector";

function MainPageContainer() {
  const history = useHistory()
  const [activeIndex, setActiveIndex] = useState(0);
  const dispatch = useDispatch();

  const hasRoleViewAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Branch.ROLE_READ));
  const hasRoleAddAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Branch.ROLE_WRITE_CREATE));
  const lang = useSelector(state => state.constant.languages);

  const companyUuid = useSelector(state => state.account.id);

  useEffect(() => {
    dispatch(fetchAccessRightStructure(companyUuid));
  }, [dispatch, companyUuid])

  useEffect(() => {
    if(!hasRoleViewAccessRight){
      history.push('/admin/dashboard')
    }
  }, [history, hasRoleViewAccessRight])

  if (!hasRoleViewAccessRight) return <LoadingComponent />;

  const tabLabels = [getLang(lang, "label.ROLE_ACCESS_CONTROL")];

  const handleChange = (event, index) => {
    setActiveIndex(index);
  };

  const handleCreateRole = () => {
    if(hasRoleAddAccessRight){
      dispatch(openCreationDialog());
    }
  };

  return (
    <MainPageComponent
      hasRoleAddAccessRight={hasRoleAddAccessRight}
      handleChange={handleChange}
      activeIndex={activeIndex}
      tabLabels={tabLabels}
      handleCreateRole={handleCreateRole}
      lang={lang}
    />
  );
}

export default MainPageContainer;
